<template>
    <div class="row">
        <div class="col-default-4 col-v-tablet-12" v-if="!hideContacts">
            <z-card full-height>
                <template v-slot:title>
                    {{ text.contacts }}
                </template>
                <template v-slot:content>
                    {{ text.contacts }}
                </template>
                <template v-slot:bottom>
                    <z-button
                        tag="a"
                        kind="text"
                        class="z-button--arrow"
                        href="#contacts"
                    >
                        {{ text.more }}
                        <template v-slot:right>
                            <z-icon
                                width="16"
                                height="16"
                                color="#E32112"
                                name="btn-arrow"
                            ></z-icon>
                        </template>
                    </z-button>

                </template>
            </z-card>
        </div>
        <div v-if="lang === 'ru'" class="col-default-4 col-v-tablet-12">
            <z-card
                theme="background"
                image="/images/products/certificates-check.jpg"
                full-height
                :link="`/${lang}/clients/claims/`"
            >
                <template v-slot:title>
                    {{ text.claims }}
                </template>
                <template v-slot:bottom>
                    <z-button
                        kind="text"
                        class="z-button--arrow"
                    >
                        {{ text.more }}
                        <template v-slot:right>
                            <z-icon
                                name="btn-arrow"
                                width="16"
                                height="16"
                                color="#E32112"
                            ></z-icon>
                        </template>
                    </z-button>
                </template>
            </z-card>
        </div>
        <div class="col-default-4 col-v-tablet-12">
            <z-card
                full-height
            >
                <template v-slot:title>
                    {{ text.feedback }}

                </template>
                <template v-slot:content>
                    <div v-html="text.feedbackText"></div>
                </template>
                <template v-slot:bottom>
                    <z-button tag="a" href="mailto:sales@tcmstrade.ru" kind="text">
                        {{ text.contactUs }}
                        <template v-slot:right>
                            <z-icon name="email" width="24" height="24"></z-icon>
                        </template>
                    </z-button>
                </template>
            </z-card>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'top-cards',
    props: {
        hideContacts: Boolean
    },
    data () {
        return {
            lang: this.$root.lang,
            text: {
                more: localize({
                    ru: 'Подробнее',
                    en: 'More'
                }),
                contacts: localize({
                    ru: 'Контакты отдела',
                    en: 'Contacts'
                }),
                priceLists: localize({
                    ru: 'Прайс-листы',
                    en: 'Price lists'
                }),
                feedback: localize({
                    ru: 'Обратная связь',
                    en: 'Feedback'
                }),
                feedbackText: localize({
                    ru: 'Если у&nbsp;вас есть вопросы, вы&nbsp;можете задать их&nbsp;нашим специалистам, написав нам на&nbsp;почту.',
                    en: 'If&nbsp;you have any questions, please contact our specialists by&nbsp;e-mail.'
                }),
                contactUs: localize({
                    ru: 'Написать',
                    en: 'Contact us'
                }),
                claims: localize({
                    ru: 'Претензионная работа',
                    en: 'Claims'
                })
            }
        }
    }
}
</script>
